export const operatorsColumns = (t: any) => [
    {
        key: "name",
        name: t('operators.columns.name'),
        fieldName: "name",
        minWidth: 300,
        maxWidth: 600,
        isResizable: true,
      },
      {
        key: "isActive",
        name: t('operators.columns.isActive'),
        fieldName: "isActive",
        minWidth: 300,
        maxWidth: 600,
        isResizable: true,
        onRender: (item: any) => t(item.isActive ? "nav.active" : "nav.inactive"),
      },
];